import { gql } from '@apollo/client';

const SELF_SERVICE_FORM_FIELDS = gql`
    fragment SelfServiceFormFields on SelfServiceFormType {
        id
        token
        name
        requestsEnabled
        autoConfirm
        introText
        excludedFields
        createdAt
        updatedAt
        requestUrl
    }
`;

const SELF_SERVICE_FORM_CLIENT_FIELDS = gql`
    fragment SelfServiceFormClientFields on SelfServiceFormClientType {
        id
        token
        status
        clientCustomerNumber
        clientName
        requesterEmail
        requesterPhone
        requesterMatchType
        note
        autoConfirmed
        confirmedAt
        createdAt
        updatedAt
        publicUrl
        form {
            id
            name
        }
    }
`;

export const GET_SELF_SERVICE_FORMS = gql`
    query SelfServiceForms($channelId: UUID!) {
        selfServiceForms(channelId: $channelId) {
            ...SelfServiceFormFields
        }
    }
    ${SELF_SERVICE_FORM_FIELDS}
`;

export const CREATE_SELF_SERVICE_FORM = gql`
    mutation CreateSelfServiceForm(
        $channelId: UUID!
        $name: String
        $introText: String
        $excludedFields: [String]
        $requestsEnabled: Boolean
        $autoConfirm: Boolean
    ) {
        createSelfServiceForm(
            channelId: $channelId
            name: $name
            introText: $introText
            excludedFields: $excludedFields
            requestsEnabled: $requestsEnabled
            autoConfirm: $autoConfirm
        ) {
            success
            form {
                ...SelfServiceFormFields
            }
        }
    }
    ${SELF_SERVICE_FORM_FIELDS}
`;

export const UPDATE_SELF_SERVICE_FORM = gql`
    mutation UpdateSelfServiceForm(
        $formId: UUID!
        $name: String
        $introText: String
        $excludedFields: [String]
        $requestsEnabled: Boolean
        $autoConfirm: Boolean
    ) {
        updateSelfServiceForm(
            formId: $formId
            name: $name
            introText: $introText
            excludedFields: $excludedFields
            requestsEnabled: $requestsEnabled
            autoConfirm: $autoConfirm
        ) {
            success
            form {
                ...SelfServiceFormFields
            }
        }
    }
    ${SELF_SERVICE_FORM_FIELDS}
`;

export const DELETE_SELF_SERVICE_FORM = gql`
    mutation DeleteSelfServiceForm($formId: UUID!) {
        deleteSelfServiceForm(formId: $formId) {
            success
        }
    }
`;

export const GET_SELF_SERVICE_FORM_CLIENTS = gql`
    query SelfServiceFormClients($channelId: UUID) {
        selfServiceFormClients(channelId: $channelId) {
            ...SelfServiceFormClientFields
        }
    }
    ${SELF_SERVICE_FORM_CLIENT_FIELDS}
`;

export const CREATE_SELF_SERVICE_FORM_CLIENT = gql`
    mutation CreateSelfServiceFormClient(
        $formId: UUID!
        $clientCustomerNumber: String!
        $clientName: String
        $clientData: GenericScalar
    ) {
        createSelfServiceFormClient(
            formId: $formId
            clientCustomerNumber: $clientCustomerNumber
            clientName: $clientName
            clientData: $clientData
        ) {
            success
            formClient {
                ...SelfServiceFormClientFields
            }
        }
    }
    ${SELF_SERVICE_FORM_CLIENT_FIELDS}
`;

export const CONFIRM_SELF_SERVICE_FORM_CLIENT = gql`
    mutation ConfirmSelfServiceFormClient(
        $clientId: UUID!
        $clientCustomerNumber: String
        $clientName: String
        $clientData: GenericScalar
    ) {
        confirmSelfServiceFormClient(
            clientId: $clientId
            clientCustomerNumber: $clientCustomerNumber
            clientName: $clientName
            clientData: $clientData
        ) {
            success
            formClient {
                ...SelfServiceFormClientFields
            }
        }
    }
    ${SELF_SERVICE_FORM_CLIENT_FIELDS}
`;

export const REJECT_SELF_SERVICE_FORM_CLIENT = gql`
    mutation RejectSelfServiceFormClient($clientId: UUID!) {
        rejectSelfServiceFormClient(clientId: $clientId) {
            success
            formClient {
                ...SelfServiceFormClientFields
            }
        }
    }
    ${SELF_SERVICE_FORM_CLIENT_FIELDS}
`;

export const DELETE_SELF_SERVICE_FORM_CLIENT = gql`
    mutation DeleteSelfServiceFormClient($clientId: UUID!) {
        deleteSelfServiceFormClient(clientId: $clientId) {
            success
        }
    }
`;
